/**
 * services/sonnerMockPrefix.js
 * ──────────────────────────────────────────────────────────────────
 * Phase M6.0 (May 9, 2026) — monkey-patch sonner's `toast.success /
 * toast.error / toast.info / toast.warning / toast(...)` to prefix
 * `[MOCK]` to the message string when the global mock-mode flag is
 * latched. Single-spot wiring at app boot — every existing call
 * site stays unchanged.
 *
 * Idempotent: re-import does nothing if the patch is already on.
 */
import { toast } from 'sonner';
import { getMockMode } from './mockModeBus';

let _installed = false;

export default function installSonnerMockPrefix() {
  if (_installed) return;
  _installed = true;

  const _wrap = (orig) => function patched(message, opts) {
    try {
      if (getMockMode() && typeof message === 'string' && !message.startsWith('[MOCK]')) {
        return orig.call(toast, `[MOCK] ${message}`, opts);
      }
    } catch (_) { /* fall through */ }
    return orig.call(toast, message, opts);
  };

  // sonner exposes named methods AND `toast` itself is callable.
  for (const method of ['success', 'error', 'info', 'warning', 'message', 'loading']) {
    if (typeof toast[method] === 'function') {
      const orig = toast[method].bind(toast);
      toast[method] = _wrap(orig);
    }
  }
}
